/**
 * OA Wishlist — 100% client-side met localStorage
 * Geen server nodig. Alle data in de browser.
 * Door Online Actief (online-actief.nl)
 */
(() => {
  var KEY = 'oaWishlist';

  /* ── Config uit Liquid ── */
  function cfg() {
    return window.OAWishlistConfig || {};
  }
  function s(key, fallback) {
    var settings = cfg().settings || {};
    var val = settings[key];
    if (val === undefined || val === '' || val === 'auto') return fallback;
    return val;
  }

  /* ── localStorage CRUD ── */
  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function setList(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    updateAll();
  }
  function has(handle) {
    return getList().some(function(i) { return i.handle === handle; });
  }
  function toggle(item) {
    var list = getList();
    if (list.some(function(x) { return x.handle === item.handle; })) {
      setList(list.filter(function(x) { return x.handle !== item.handle; }));
    } else {
      item.addedAt = Date.now();
      setList([item].concat(list));
    }
  }
  function removeItem(handle) {
    setList(getList().filter(function(x) { return x.handle !== handle; }));
  }

  /* ── SVGs ── */
  function themeHeartSvg() {
    return '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="icon-theme icon-theme-stroke oa-heart-icon" viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"></path></svg>';
  }
  function cardHeartSvg() {
    return '<svg class="oa-heart" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  }

  /* ── Auto-detect: try multiple selectors ── */
  function autoFind(customSelector, fallbacks) {
    if (customSelector) {
      var el = document.querySelector(customSelector);
      if (el) return el;
    }
    for (var i = 0; i < fallbacks.length; i++) {
      var el = document.querySelector(fallbacks[i]);
      if (el) return el;
    }
    return null;
  }

  /* ── Common selectors across popular Shopify themes ── */
  var CART_SELECTORS = [
    '.oa-header__icons a[href*="/cart"]',
    '[data-oa-fallback-icons] a[href*="/cart"]',
    '[data-oa-theme-icons] a[href*="/cart"]',
    '.navlink--cart',
    'a[href="/cart"]',
    'a[href$="/cart"]',
    'a[href*="/cart?"]',
    '.header__icon--cart a',
    '.site-header__cart',
    '.cart-icon-bubble',
    '.header-cart-btn',
    'a.cart-link',
    '[data-cart-toggle]',
    '.js-drawer-open-right',
    '.Header__Icon--cart',
  ];
  var PRODUCT_FORM_SELECTORS = [
    '.product-form',
    'form[action*="/cart/add"]',
    '.product-single__form',
    '.product__form',
    '.ProductForm',
    'product-form',
    '.product-form__buttons',
  ];
  var CARD_SELECTORS = [
    '.product-grid-item',
    '.product__grid__item',
    '.card-wrapper',
    '.product-card-wrapper',
    '.grid-product',
    '.product-card',
    '.grid__item .grid-view-item',
    '.collection-product-card',
    '.ProductItem',
    '.product-index',
  ];
  var MOBILE_CART_SELECTORS = [
    '.oa-header__mob-icons a[href$="/cart"]',
    '.oa-header__mob-icons a[href*="/cart"]',
    '.header__mobile__right a[href*="cart"]',
    '.header__mobile__button[data-drawer-toggle="drawer-cart"]',
    '.header__icon--cart',
    '.mobile-nav__icon--cart',
  ];

  /* ── Header icon (desktop) ── */
  function insertHeaderIcon() {
    if (s('showHeaderIcon', true) === false) return;
    if (document.querySelector('.oa-wishlist-header-icon-desktop')) return;

    /* Verwijder dubbele theme-side wishlist iconen (voorkom 2x Favorieten) */
    var headerScopes = document.querySelectorAll('[data-oa-header], [data-oa-theme-icons], header');
    headerScopes.forEach(function(scope) {
      /* Match alles wat naar wishlist/favorieten ruikt: href, class, of zichtbare text */
      var candidates = scope.querySelectorAll('a, button');
      candidates.forEach(function(el) {
        /* Skip onze eigen elementen */
        if (el.className && typeof el.className === 'string' && el.className.indexOf('oa-') !== -1) return;
        if (el.closest('.oa-wishlist-header-icon-desktop, .oa-wishlist-header-icon-mobile, .oa-header__mobile-menu, [data-oa-mobile-menu]')) return;
        var href = (el.getAttribute('href') || '').toLowerCase();
        var cls = (el.className || '').toLowerCase();
        var txt = (el.textContent || '').toLowerCase();
        if (href.indexOf('wishlist') !== -1 || href.indexOf('favorieten') !== -1 || href.indexOf('favorites') !== -1 ||
            cls.indexOf('wishlist') !== -1 || cls.indexOf('favorit') !== -1 ||
            txt.indexOf('favoriet') !== -1 || txt.indexOf('favorit') !== -1) {
          /* Verberg het theme-icoon zodat alleen onze versie zichtbaar is */
          el.style.display = 'none';
          el.setAttribute('data-oa-removed-fav', '1');
        }
      });
    });

    var cart = autoFind(s('headerCartSelector', ''), CART_SELECTORS);
    if (!cart) return;

    var favPath = s('favoritesPagePath', cfg().favoritesPagePath || '/pages/wishlist');
    var iconWithBadge =
      '<span class="oa-wishlist-icon-wrap">' +
        themeHeartSvg() +
        '<span class="oa-wishlist-count-badge oa-wishlist-hidden" data-oa-wishlist-count>0</span>' +
      '</span>';

    var cartButton = cart.closest('.header__desktop__button') || cart.closest('.header__icon') || cart.closest('[class*="header"] [class*="icon"]');

    if (cartButton) {
      var wrapper = document.createElement('div');
      wrapper.className = (cartButton.className.split(' ')[0] || '') + ' oa-wishlist-header-icon-desktop';
      wrapper.innerHTML = '<a href="' + favPath + '" class="navlink">' + iconWithBadge + '</a>';
      cartButton.parentElement.insertBefore(wrapper, cartButton);
    } else {
      var wrapper = document.createElement('span');
      wrapper.className = 'oa-wishlist-header-icon-desktop';
      wrapper.style.cssText = 'display:inline-flex;align-items:center;vertical-align:middle;';
      wrapper.innerHTML = '<a href="' + favPath + '" style="position:relative;display:inline-flex;align-items:center;justify-content:center;width:44px;height:44px;color:inherit;text-decoration:none">' + iconWithBadge + '</a>';
      cart.parentElement.insertBefore(wrapper, cart);
    }
    insertMobileHeaderIcon(favPath);
  }

  /* ── Header icon (mobile) ── */
  function insertMobileHeaderIcon(favPath) {
    /* Cleanup: verwijder mobile-iconen die per ongeluk in desktop-container staan */
    document.querySelectorAll('.oa-header__icons .oa-wishlist-header-icon-mobile, [data-oa-fallback-icons] .oa-wishlist-header-icon-mobile').forEach(function(el) { el.remove(); });
    if (document.querySelector('.oa-wishlist-header-icon-mobile')) return;
    var mobileCart = autoFind('', MOBILE_CART_SELECTORS);
    if (!mobileCart) return;
    /* Skip als gevonden 'mobile' cart eigenlijk in desktop-container zit */
    if (mobileCart.closest('.oa-header__icons, [data-oa-fallback-icons]') && !mobileCart.closest('.oa-header__mob-icons')) return;

    var link = document.createElement('a');
    link.className = (mobileCart.className || '') + ' oa-wishlist-header-icon-mobile';
    link.href = favPath;
    link.setAttribute('aria-label', 'Favorieten');
    link.innerHTML =
      '<span class="oa-wishlist-icon-wrap">' +
        themeHeartSvg() +
        '<span class="oa-wishlist-count-badge oa-wishlist-hidden" data-oa-wishlist-count>0</span>' +
      '</span>';
    mobileCart.parentElement.insertBefore(link, mobileCart);
  }

  /* ── Product page detection ── */
  function productJsonFromPage() {
    var sa = window.ShopifyAnalytics?.meta?.product;
    if (sa && sa.handle) {
      return {
        productId: sa.id ? String(sa.id) : null,
        handle: sa.handle,
        title: sa.product?.title || document.title.split('–')[0].split('|')[0].trim(),
        url: window.location.pathname,
        image: document.querySelector('.product__media img, .product-single__photo img, .product__images img, img[src*="/products/"]')?.src || null
      };
    }
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!match) return null;
    return {
      productId: null,
      handle: match[1],
      title: document.querySelector('.product__title, .product-single__title, h1.product-title, h1')?.textContent?.trim() || document.title.split('–')[0].split('|')[0].trim(),
      url: window.location.pathname,
      image: document.querySelector('.product__media img, .product-single__photo img, .product__images img, img[src*="/products/"]')?.src || null
    };
  }

  /* ── Product page button ── */
  function insertProductButton() {
    if (s('showProductButton', true) === false) return;
    if (document.querySelector('[data-oa-wishlist-product-btn]')) return;

    var target = autoFind(s('productFormSelector', ''), PRODUCT_FORM_SELECTORS);
    if (!target) return;

    var item = productJsonFromPage();
    if (!item || !item.handle) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'oa-wishlist-product-btn';
    btn.dataset.oaWishlistProductBtn = 'true';
    btn.innerHTML = cardHeartSvg() + '<span>' + s('buttonText', 'Favoriet') + '</span>';
    btn.addEventListener('click', function() {
      toggle(item);
      btn.classList.remove('oa-just-toggled');
      void btn.offsetWidth; /* force reflow */
      btn.classList.add('oa-just-toggled');
    });
    target.parentNode.insertBefore(btn, target.nextSibling);
  }

  /* ── Card hearts ── */
  function attachCardButtons() {
    if (s('showCardHearts', true) === false) return;

    var customSel = s('cardSelector', '');
    var allSelectors = [];
    if (customSel) customSel.split(',').forEach(function(sel) { if (sel.trim()) allSelectors.push(sel.trim()); });
    CARD_SELECTORS.forEach(function(sel) { allSelectors.push(sel); });

    var seen = {};
    var unique = [];
    allSelectors.forEach(function(sel) { if (!seen[sel]) { seen[sel] = true; unique.push(sel); } });

    var cards = document.querySelectorAll(unique.join(','));
    cards.forEach(function(card) {
      if (card.querySelector('[data-oa-wishlist-card-btn]')) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var parts = href.split('/products/');
      if (parts.length < 2) return;
      var handle = parts[1].split('?')[0].split('#')[0];
      if (!handle) return;

      var img = card.querySelector('img');
      var title = (img && img.getAttribute('alt')) || '';
      if (!title) {
        var titleEl = card.querySelector('[class*="title"], [class*="name"], h3, h4');
        title = titleEl ? titleEl.textContent.trim() : handle;
      }
      var item = { handle: handle, title: title, url: href, image: img ? img.src : null };

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'oa-wishlist-card-btn';
      btn.dataset.oaWishlistCardBtn = 'true';
      btn.innerHTML = cardHeartSvg();
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggle(item);
        btn.classList.remove('oa-just-toggled');
        void btn.offsetWidth;
        btn.classList.add('oa-just-toggled');
      });

      var style = window.getComputedStyle(card);
      if (style.position === 'static') card.style.position = 'relative';
      card.appendChild(btn);
    });
  }

  /* ── Update UI state ── */
  function updateAll() {
    var list = getList();
    var count = list.length;
    var btnText = s('buttonText', 'Favoriet');
    var btnTextActive = s('buttonTextActive', 'Opgeslagen');

    /* Header iconen — has-items class + re-trigger badge pop */
    document.querySelectorAll('.oa-wishlist-header-icon-desktop, .oa-wishlist-header-icon-mobile').forEach(function(wrap) {
      wrap.classList.toggle('has-items', count > 0);
    });

    document.querySelectorAll('[data-oa-wishlist-count]').forEach(function(el) {
      var prev = el.textContent;
      var next = count > 99 ? '99+' : String(count);
      el.textContent = next;
      el.classList.toggle('oa-wishlist-hidden', count === 0);
      /* Re-trigger pop animatie als count veranderd én nu zichtbaar is */
      if (prev !== next && count > 0) {
        el.classList.remove('oa-just-bumped');
        void el.offsetWidth;
        el.classList.add('oa-just-bumped');
      }
    });

    /* Heart icon pulse op header bij toggle */
    document.querySelectorAll('.oa-wishlist-header-icon-desktop .oa-heart-icon, .oa-wishlist-header-icon-mobile .oa-heart-icon').forEach(function(svg) {
      svg.classList.remove('oa-just-pulsed');
      void svg.offsetWidth;
      svg.classList.add('oa-just-pulsed');
    });

    document.querySelectorAll('[data-oa-wishlist-product-btn]').forEach(function(btn) {
      var item = productJsonFromPage();
      var active = item && item.handle && has(item.handle);
      btn.classList.toggle('is-active', !!active);
      var label = btn.querySelector('span');
      if (label) label.textContent = active ? btnTextActive : btnText;
    });

    document.querySelectorAll('[data-oa-wishlist-card-btn]').forEach(function(btn) {
      var card = btn.parentElement;
      var link = card ? card.querySelector('a[href*="/products/"]') : null;
      var href = link ? (link.getAttribute('href') || '') : '';
      var parts = href.split('/products/');
      var handle = parts.length > 1 ? parts[1].split('?')[0].split('#')[0] : '';
      btn.classList.toggle('is-active', !!handle && has(handle));
    });

    /* Custom event zodat popups & andere componenten live mee bewegen */
    try {
      window.dispatchEvent(new CustomEvent('oa-wishlist:changed', { detail: { count: count, list: list } }));
    } catch (e) {}

    // Update favorites page if we're on it
    if (isFavoritesPage()) renderFavoritesPage();
  }

  /* ── Apply colors from settings ── */
  function applyColors() {
    var accent = s('accentColor', '#55fffa');
    var icon = s('iconColor', '#1d1d1b');
    document.documentElement.style.setProperty('--oa-wishlist-accent', accent);
    document.documentElement.style.setProperty('--oa-wishlist-text', icon);
  }

  /* ── Favorites page (full takeover — hides 404, renders own template) ── */
  function isFavoritesPage() {
    var favPath = cfg().favoritesPagePath || '/pages/wishlist';
    var path = window.location.pathname.replace(/\/$/, '');
    return path === favPath || path === favPath.replace(/\/$/, '');
  }

  function takeoverPage() {
    /* Hide ALL content inside <main> (including 404 messages) */
    var main = document.querySelector('main') || document.getElementById('MainContent') || document.getElementById('main');
    if (!main) return null;

    /* Hide existing sections inside main */
    Array.from(main.children).forEach(function(child) {
      child.style.display = 'none';
    });

    /* Create our own full-width container */
    var page = document.createElement('div');
    page.id = 'oa-wishlist-page';
    page.className = 'oa-wishlist-page';
    main.appendChild(page);
    return page;
  }

  function renderFavoritesPage() {
    var page = document.getElementById('oa-wishlist-page');
    if (!page) {
      page = takeoverPage();
      if (!page) return;
    }

    var list = getList();
    var title = s('favoritesTitle', 'Mijn favorieten');
    var emptyText = s('favoritesEmptyText', 'Je hebt nog geen favorieten opgeslagen.');
    var emptyBtn = s('favoritesEmptyButton', 'Bekijk collecties');
    var accent = s('accentColor', '#55fffa');
    var count = list.length;

    /* ── Page header: hartje + titel alleen als er items zijn ── */
    var html = '';
    if (count > 0) {
      html +=
        '<div class="oa-fav-header">' +
          '<div class="oa-fav-header-heart">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36">' +
              '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z" fill="' + accent + '" stroke="none"/>' +
            '</svg>' +
          '</div>' +
          '<h1 class="oa-fav-header-title">' + title + '</h1>' +
          '<p class="oa-fav-header-sub">Jouw opgeslagen favoriete producten op één plek.</p>' +
          '<p class="oa-fav-header-count">' + count + ' product' + (count !== 1 ? 'en' : '') + '</p>' +
        '</div>';
    }

    /* ── Empty state ── */
    if (count === 0) {
      html +=
        '<div class="oa-fav-empty">' +
          '<div class="oa-fav-empty-inner">' +
            '<svg class="oa-fav-empty-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="80" height="80">' +
              '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
            '<p class="oa-fav-empty-text">' + emptyText + '</p>' +
            '<a href="/collections" class="oa-fav-empty-btn">' + emptyBtn + '</a>' +
          '</div>' +
        '</div>';
    } else {
      /* ── Product grid ── */
      html += '<div class="oa-fav-section"><div class="oa-fav-grid">';
      list.forEach(function(item) {
        var imgSrc = item.image || '';
        var productUrl = item.url || '/products/' + item.handle;
        html +=
          '<div class="oa-fav-card" data-handle="' + item.handle + '">' +
            '<button type="button" class="oa-fav-remove" data-handle="' + item.handle + '" aria-label="Verwijderen">' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16"><path d="M18 6L6 18M6 6l12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
            '</button>' +
            '<a href="' + productUrl + '" class="oa-fav-card-link">' +
              '<div class="oa-fav-img-wrap">' +
                (imgSrc
                  ? '<img src="' + imgSrc + '" alt="' + (item.title || item.handle).replace(/"/g, '&quot;') + '" class="oa-fav-img" loading="lazy">'
                  : '<div class="oa-fav-img-placeholder"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="40" height="40"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z" fill="none" stroke="currentColor" stroke-width="1.2" opacity="0.25"/></svg></div>') +
              '</div>' +
              '<div class="oa-fav-card-info">' +
                '<p class="oa-fav-title">' + (item.title || item.handle) + '</p>' +
              '</div>' +
            '</a>' +
          '</div>';
      });
      html += '</div></div>';
    }

    page.innerHTML = html;

    /* Attach remove handlers */
    page.querySelectorAll('.oa-fav-remove').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        removeItem(btn.getAttribute('data-handle'));
      });
    });

    /* Update document title */
    document.title = title + ' — ' + (cfg().shop || '').replace('.myshopify.com', '');
  }

  /* ── Boot ── */
  function boot() {
    applyColors();
    insertHeaderIcon();
    insertProductButton();
    attachCardButtons();

    if (isFavoritesPage()) renderFavoritesPage();

    updateAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);

  /* Live updates wanneer andere bronnen (oa-product-block.js) localStorage muteren */
  window.addEventListener('storage', function (e) { if (e.key === KEY) updateAll(); });
  window.addEventListener('oa-wishlist:changed', updateAll);
  document.addEventListener('oa-wishlist:changed', updateAll);
})();
